/**
 * Dual view's read-only reference panel is an iframe tagged `readonly-frame`, and renders without
 * app chrome. read-only-frame-checker.js sets the matching CSS opt-out on the same signal.
 */
export const isEmbeddedReferenceFrame = (): boolean => {
	if (typeof window === "undefined") return false;
	try {
		return !!window.frameElement && (window.frameElement as HTMLElement).classList.contains("readonly-frame");
	} catch {
		return false;
	}
};
